import { render, staticRenderFns } from "./VFormField.vue?vue&type=template&id=ebafe52c&scoped=true&lang=pug&"
import script from "./VFormField.vue?vue&type=script&lang=js&"
export * from "./VFormField.vue?vue&type=script&lang=js&"
import style0 from "./VFormField.vue?vue&type=style&index=0&id=ebafe52c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebafe52c",
  null
  
)

export default component.exports